const createPiece = (color, shape) => ({ squareWidth }) => (
  <div
    style={{
      width: squareWidth,
      height: squareWidth,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <svg width={squareWidth * 0.8} height={squareWidth * 0.8} viewBox="0 0 16 16">
      <g style={{ imageRendering: 'pixelated' }}>
        {color === 'w' ? shape.light : shape.dark}
      </g>
    </svg>
  </div>
);

// Color palette
const colors = {
  light: {
    primary: '#D4B483',    // Light brown
    secondary: '#C19A6B',  // Medium brown
    outline: '#8B4513',    // Dark brown
    highlight: '#E8C8A0',  // Highlight brown
  },
  dark: {
    primary: '#6B4423',    // Dark brown
    secondary: '#523018',  // Darker brown
    outline: '#2F1810',    // Almost black
    highlight: '#8B5E34',  // Highlight dark brown
  }
};

const pieces = {
  pawn: {
    light: (
      <>
        <path d="M6,12 h4 v1 h-4 z" fill="#FFFFFF" />
        <path d="M7,5 h2 v7 h-2 z" fill="#FFFFFF" />
        <path d="M6,4 h4 v1 h-4 z" fill="#FFFFFF" />
        <path d="M5,13 h6 v1 h-6 z" fill="#FFFFFF" />
        <path d="M5,12 h1 v1 h-1 z M10,12 h1 v1 h-1 z" fill="#444444" />
        <path d="M6,4 h-1 v1 h1 z M10,4 h1 v1 h-1 z" fill="#444444" />
        <path d="M5,13 h7 v1 h-7 z" fill="#444444" />
      </>
    ),
    dark: (
      <>
        <path d="M6,12 h4 v1 h-4 z" fill="#7BA1D9" />
        <path d="M7,5 h2 v7 h-2 z" fill="#7BA1D9" />
        <path d="M6,4 h4 v1 h-4 z" fill="#7BA1D9" />
        <path d="M5,13 h6 v1 h-6 z" fill="#7BA1D9" />
        <path d="M5,12 h1 v1 h-1 z M10,12 h1 v1 h-1 z" fill="#444444" />
        <path d="M6,4 h-1 v1 h1 z M10,4 h1 v1 h-1 z" fill="#444444" />
        <path d="M5,13 h7 v1 h-7 z" fill="#444444" />
      </>
    )
  },
  rook: {
    light: (
      <>
        <rect x="10" y="8" width="12" height="16" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="8" y="6" width="4" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="6" width="4" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="20" y="6" width="4" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
      </>
    ),
    dark: (
      <>
        <rect x="10" y="8" width="12" height="16" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="8" y="6" width="4" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="6" width="4" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="20" y="6" width="4" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
      </>
    )
  },
  knight: {
    light: (
      <>
        <rect x="10" y="20" width="12" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="12" y="12" width="8" height="8" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="8" width="8" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="18" y="6" width="4" height="2" fill="#D4B483" stroke="#000000" strokeWidth="1" />
      </>
    ),
    dark: (
      <>
        <rect x="10" y="20" width="12" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="12" y="12" width="8" height="8" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="8" width="8" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="18" y="6" width="4" height="2" fill="#6B4423" stroke="#000000" strokeWidth="1" />
      </>
    )
  },
  bishop: {
    light: (
      <>
        <rect x="12" y="20" width="8" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="10" width="4" height="10" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="13" y="6" width="6" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="15" y="4" width="2" height="2" fill="#D4B483" stroke="#000000" strokeWidth="1" />
      </>
    ),
    dark: (
      <>
        <rect x="12" y="20" width="8" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="10" width="4" height="10" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="13" y="6" width="6" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="15" y="4" width="2" height="2" fill="#6B4423" stroke="#000000" strokeWidth="1" />
      </>
    )
  },
  queen: {
    light: (
      <>
        <rect x="12" y="20" width="8" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="8" width="4" height="12" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="10" y="6" width="12" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="8" y="4" width="4" height="2" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="4" width="4" height="2" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="20" y="4" width="4" height="2" fill="#D4B483" stroke="#000000" strokeWidth="1" />
      </>
    ),
    dark: (
      <>
        <rect x="12" y="20" width="8" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="8" width="4" height="12" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="10" y="6" width="12" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="8" y="4" width="4" height="2" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="4" width="4" height="2" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="20" y="4" width="4" height="2" fill="#6B4423" stroke="#000000" strokeWidth="1" />
      </>
    )
  },
  king: {
    light: (
      <>
        <rect x="12" y="20" width="8" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="8" width="4" height="12" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="12" y="6" width="8" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="2" width="4" height="4" fill="#D4B483" stroke="#000000" strokeWidth="1" />
        <rect x="13" y="3" width="6" height="2" fill="#D4B483" stroke="#000000" strokeWidth="1" />
      </>
    ),
    dark: (
      <>
        <rect x="12" y="20" width="8" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="8" width="4" height="12" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="12" y="6" width="8" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="14" y="2" width="4" height="4" fill="#6B4423" stroke="#000000" strokeWidth="1" />
        <rect x="13" y="3" width="6" height="2" fill="#6B4423" stroke="#000000" strokeWidth="1" />
      </>
    )
  }
};

export const customPieces = {
  wP: createPiece('w', pieces.pawn),
  bP: createPiece('b', pieces.pawn),
  wR: createPiece('w', pieces.rook),
  bR: createPiece('b', pieces.rook),
  wN: createPiece('w', pieces.knight),
  bN: createPiece('b', pieces.knight),
  wB: createPiece('w', pieces.bishop),
  bB: createPiece('b', pieces.bishop),
  wQ: createPiece('w', pieces.queen),
  bQ: createPiece('b', pieces.queen),
  wK: createPiece('w', pieces.king),
  bK: createPiece('b', pieces.king),
};

// Add the board customization
export const customBoardStyle = {
  borderRadius: 0,
  boxShadow: 'none',
};

export const customSquareStyles = {
  light: {
    backgroundColor: '#EEEED2',
  },
  dark: {
    backgroundColor: '#769656',
  },
}; 